import { AxiosError } from "axios";

export function formatMessageError(error: unknown) {
  if (error instanceof AxiosError) {
    if (!error.response) {
      return `Erro de conexão com o servidor. Servidor se encontra com instabilidade no momento.`;
    }

    if (error.status === 500) {
      return `Erro ${error.response?.status}: ${error.response?.data?.title || "Erro interno no servidor"}. ${error.response?.data?.detail || ""}`;
    }

    if (error.status === 413) {
      return `Erro ${error.response?.status}: O arquivo enviado é muito grande e excede o limite permitido pelo servidor.`;
    }

    if (error.response?.data.objects) {
      const itens = error.response?.data.objects
        .map(
          (item: { name: string; userMessage: string }) =>
            `${item.name}: ${item.userMessage}`
        )
        .join("\n");

      return `Erro ${error.response?.status}: ${error.response?.data?.detail}\n${itens}`;
    }

    return `Erro ${error.response?.status}: ${error.response?.data?.detail}.`;
  }

  if (error instanceof Error) {
    return `Erro: ${error.message}`;
  }

  return "Erro desconhecido. Favor entrar em contato com o suporte";
}
